import {IGetMediaQueryParams} from '../../service/userApi';
import Constants, {OrderByQueryString, SortMetric} from '../../constants/Constants';
import {IFolderTreeNode} from '../../model/folderTreeNode';
import {MediaContentType} from '../../model/baseMedia';

export const buildMediaQueryParams = (sortMetric: SortMetric, fromHash?: string, activeFolder?: IFolderTreeNode, mediaContentFilters?: MediaContentType[], includeExcludedMedia?: boolean) => {
   const fromValue = fromHash;
   const queryParams: Partial<IGetMediaQueryParams> = fromValue ? {from: fromValue, take: Constants.mediaPaginationBatchSize} : {take: Constants.mediaPaginationBatchSize};

   if (activeFolder?.Hash) {
      queryParams.folderHash = activeFolder.Hash;
   }

   Object.assign(queryParams, buildSortMetricQueryParams(sortMetric));

   queryParams.includeExcludedMedia = typeof includeExcludedMedia === 'boolean' ? includeExcludedMedia : true;

   if (mediaContentFilters) {
      queryParams.mediaContentFilter = mediaContentFilters;
   }

   return queryParams;
};

export const buildSortMetricQueryParams = (sortMetric: SortMetric) => {
   const sortMetricQueryParams: Partial<IGetMediaQueryParams> = {};
   if (sortMetric === SortMetric.dateAscending) {
      sortMetricQueryParams.orderBy = OrderByQueryString.date;
   } else if (sortMetric === SortMetric.dateDescending) {
      sortMetricQueryParams.orderBy = OrderByQueryString.date;
      sortMetricQueryParams.descending = true;
   } else if (sortMetric === SortMetric.titleAscending) {
      sortMetricQueryParams.orderBy = OrderByQueryString.title;
   } else if (sortMetric === SortMetric.titleDescending) {
      sortMetricQueryParams.orderBy = OrderByQueryString.title;
      sortMetricQueryParams.descending = true;
   } else if (sortMetric === SortMetric.viewsAscending) {
      sortMetricQueryParams.orderBy = OrderByQueryString.views;
   } else if (sortMetric === SortMetric.viewsDescending) {
      sortMetricQueryParams.orderBy = OrderByQueryString.views;
      sortMetricQueryParams.descending = true;
   }
   return sortMetricQueryParams;
};
